import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {SearchContactPage} from '../../modals/search-contact/search-contact.page';
import {ModalController, Platform} from '@ionic/angular';
import {ContactModel} from '../../models/contact.model';
import {LokijsService} from '../../services/database/lokijs.service';
import {DocumentModel} from '../../models/document.model';
import {BlankSignature} from '../../definitions/blank-signature';
import {ConfigurationService} from 'src/app/services/configuration.service';
import {QuestionsPage} from 'src/app/modals/questions/questions.page';
import {MobileConfigurationModel} from 'src/app/models/mobile-configuration.model';
import {CallContactService} from '../../services/call-contact.service';
import {DrawSignaturePage} from '../../modals/draw-signature/draw-signature.page';
import {ScreenOrientation} from '@ionic-native/screen-orientation/ngx';

@Component({
    selector: 'app-signature',
    templateUrl: './signature.component.html',
    styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnInit {

    @Input() document: DocumentModel;
    @Output() signatureChange: EventEmitter<string> = new EventEmitter<string>();
    mobileConfig: MobileConfigurationModel;

    constructor(private modalController: ModalController,
                private screenOrientation: ScreenOrientation,
                private plt: Platform,
                private lokiJs: LokijsService,
                private blankSignature: BlankSignature,
                private configuration: ConfigurationService,
                public callContact: CallContactService) {
    }

    ngOnInit() {
        if (!this.document.signatureContact) {
            this.document.signatureContact = new ContactModel();
        }
        this.mobileConfig = this.configuration.getMobileConfiguration();
    }

    async openModalSearchContact() {
        const modal = await this.modalController.create({
            component: SearchContactPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                this.document.signatureContact = dataReturned.data;
                if (this.document.documentType === 1 && this.mobileConfig.mobilehireShowQuestions === 1) {
                    this.openModalQuestions();
                } else {
                    this.openModalDrawSignature();
                }
            }
        });
        return await modal.present();
    }

    async openModalQuestions() {
        //if (this.plt.is('cordova')) {
        //    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
       // }
        const modal = await this.modalController.create({
            component: QuestionsPage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            this.openModalDrawSignature();
        });
        return await modal.present();
    }

    async openModalDrawSignature() {
        //if (this.plt.is('cordova')) {
        //    this.screenOrientation.lock(this.screenOrientation.ORIENTATIONS.LANDSCAPE);
       //}
        
        const modal = await this.modalController.create({
            component: DrawSignaturePage,
            cssClass: 'modal-fullscreen',
            componentProps: {
                'document': this.document
            }
        });

        modal.onDidDismiss().then((dataReturned) => {
            if (dataReturned.data) {
                if (dataReturned.data !== this.blankSignature.blankSignature) {
                    this.document.signature = dataReturned.data;
                } else {
                    this.document.signature = null;
                }
                this.signatureChange.emit(this.document.signature);
            }
        });
        return await modal.present();
    }

}
